module.exports = __webpack_public_path__ + "image4.jpg";